import * as React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';

import Project from './scenes/Project';
import About from './scenes/About';
import Home from './scenes/Home';
import Archive from './scenes/Project/Archive';

function App() {
  return (
    <Switch>
      <Route component={About} path="/about" exact />
      <Route component={Home} path="/egg" exact />
      <Route component={Project} path="/project/:projectType/:projectSlug?" />
      <Route
        component={Archive}
        path="/archive/project/:projectType/:projectSlug?"
      />
      <Route render={() => <Redirect to="/project/commission" />} />
    </Switch>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx